export function currencyFormat(
  num?: number,
  currency: string = '€',
  fromCts: boolean = false
): string {
  if (num === undefined) return '--'

  const number = fromCts ? num / 100 : num
  return (
    number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ' + currency
  )
}
